import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageWidget = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_104_35886)",
		children: /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_104_35886)",
			children: /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip2_104_35886)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "mask0_104_35886",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 0,
					y: 0,
					width: 32,
					height: 32,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M31.7538 0.246094H0.246094V31.7538H31.7538V0.246094Z",
						fill: "white"
					})
				}), /* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask0_104_35886)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M30.0002 2.70801H2.32415C1.99174 2.70801 1.72266 2.97699 1.72266 3.30953V28.5206C1.72266 28.8531 1.99174 29.1219 2.32415 29.1219H30.0002C30.3328 29.1219 30.6018 28.8531 30.6018 28.5206V3.30953C30.6018 2.97699 30.3328 2.70801 30.0002 2.70801ZM29.3987 27.919H2.92557V3.91112H29.3987V27.919ZM10.1338 14.7398C12.124 14.7398 13.7428 13.1208 13.7428 11.1304C13.7428 9.14011 12.124 7.521 10.1338 7.521C8.14353 7.521 6.52467 9.14011 6.52467 11.1304C6.52467 13.1208 8.14353 14.7398 10.1338 14.7398ZM10.1338 8.72425C11.4608 8.72425 12.5398 9.80344 12.5398 11.1304C12.5398 12.4576 11.4608 13.5367 10.1338 13.5367C8.80682 13.5367 7.72773 12.4576 7.72773 11.1304C7.72773 9.80344 8.80682 8.72425 10.1338 8.72425ZM5.5437 25.3688C5.54789 25.3722 5.55281 25.3728 5.5569 25.376C5.61071 25.4183 5.6688 25.4524 5.73531 25.4746C5.76367 25.4846 5.79222 25.4864 5.82136 25.4922C5.85592 25.4983 5.88738 25.5126 5.92391 25.5126H26.3747C26.458 25.5126 26.5373 25.4958 26.6094 25.4652C26.6137 25.4633 26.6162 25.4595 26.6206 25.4575C26.6889 25.4268 26.751 25.3854 26.8027 25.3327C26.8288 25.3063 26.8433 25.2724 26.864 25.2421C26.8866 25.2084 26.9143 25.1785 26.9301 25.1403C26.9801 25.0192 26.9808 24.883 26.9438 24.7505C26.9369 24.7264 26.9383 24.6992 26.9288 24.6765L22.0465 13.1589C21.962 12.9592 21.7757 12.8206 21.5602 12.7966C21.347 12.7694 21.1326 12.8659 21.0052 13.0414L16.1608 19.7351L12.3454 17.2752C12.0924 17.1127 11.7575 17.1626 11.5618 17.3904L5.51761 24.4728C5.39906 24.5827 5.32231 24.7366 5.32231 24.9111C5.32231 25.0959 5.41014 25.2552 5.54114 25.3654C5.54223 25.3663 5.54267 25.3679 5.5437 25.3688ZM12.1357 18.5719L15.9881 21.055C16.2565 21.2277 16.6137 21.1613 16.8016 20.9017L21.3547 14.61L25.4662 24.3095H7.23882L12.1357 18.5719Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M13.7435 11.1299C13.7435 13.1203 12.1248 14.7393 10.1345 14.7393C8.1443 14.7393 6.52539 13.1203 6.52539 11.1299C6.52539 9.13966 8.1443 7.52051 10.1345 7.52051C12.1248 7.52051 13.7435 9.13966 13.7435 11.1299Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M5.5569 25.3755C5.55276 25.3723 5.54784 25.3717 5.54366 25.3683C5.54262 25.3674 5.54218 25.3658 5.5411 25.3648C5.41009 25.2546 5.32227 25.0954 5.32227 24.9105C5.32227 24.736 5.39902 24.5821 5.51756 24.4722L11.5618 17.3899C11.7574 17.1621 12.0923 17.1121 12.3453 17.2747L16.1607 19.7345L21.0052 13.0409C21.1325 12.8653 21.3469 12.7689 21.5602 12.796C21.7757 12.8201 21.9619 12.9586 22.0465 13.1583L26.9287 24.6759C26.9382 24.6987 26.9369 24.7258 26.9437 24.75C26.9808 24.8824 26.9801 25.0187 26.93 25.1398C26.9143 25.178 26.8866 25.2078 26.864 25.2415C26.8432 25.2718 26.8287 25.3057 26.8027 25.3322C26.751 25.3849 26.6888 25.4263 26.6206 25.457C26.6162 25.459 26.6137 25.4628 26.6094 25.4646C26.5373 25.4952 26.458 25.5121 26.3746 25.5121H5.92387C5.88734 25.5121 5.85588 25.4978 5.82132 25.4916C5.79217 25.4859 5.76362 25.484 5.73526 25.4741C5.66875 25.4519 5.61066 25.4178 5.5569 25.3755Z",
							fill: "currentColor"
						})
					]
				})]
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_104_35886",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_104_35886",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip2_104_35886",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 31.5077,
				fill: "white",
				transform: "translate(0 0.246094)"
			})
		})
	] })]
});
export default SvgImageWidget;
